export default [
  {
    key: 'company',
    value: '',
    label: 'アライアンス名',
    name: 'company',
    as: 'plaintext',
  },
  {
    key: 'fullname',
    value: '',
    label: '氏名',
    rules: { required: true, minmax: { min: 1, max: 100 } },
    name: 'fullName',
    as: 'input',
  },
  {
    key: 'email',
    value: '',
    label: 'メールアドレス',
    rules: { required: true, email: true },
    name: 'email',
    as: 'input',
  },
  {
    key: 'phone',
    value: '',
    label: '電話番号',
    rules: { required: true, phone: true },
    as: 'input',
  },
  {
    key: 'category',
    value: 'アプリについて',
    label: 'カテゴリ',
    as: 'select',
    options: [
      {
        label: 'アプリについて',
        value: 'アプリについて',
      },
      {
        label: '管理画面について',
        value: '管理画面について',
      },
      {
        label: '配信について/その他',
        value: '配信について/その他',
      },
    ],
  },
  {
    key: 'image',
    value: '',
    label: 'ファイル添付',
    as: 'inputFile',
  },
  {
    key: 'content',
    value: '',
    label: '内容',
    rules: { required: true, scope: { min: 1, max: 1000 } },
    as: 'area',
  },
]

export const feedbackFields = {
  image: '',
  image_filename: '',
}
